/**
 * Sales-feature constants.
 *
 * The "Book of business" (paying-accounts revenue) is restricted to the company head only — not
 * other managers. Frontend gates nav/route/render on this; the backend (finance /accounts-revenue
 * and master-data /accounts-summary) enforces the same via an X-User-Email allowlist. Kept in one
 * place so the FE gate and the note about the backend allowlist stay in sync.
 */
export const COMPANY_HEAD_EMAIL = 'nipin@infinitylogisticsme.com'

export function isCompanyHead(email: string | null | undefined): boolean {
  return (email ?? '').trim().toLowerCase() === COMPANY_HEAD_EMAIL
}
